import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-basic-modal',
  templateUrl: './basic-modal.component.html',
  styleUrls: ['./basic-modal.component.css']
})
export class BasicModalComponent implements OnInit {

	@Input() title: string;
	@Input() context: any = {};
	@Input() template: TemplateRef<any>;
	@Input() action: string;
	@Input() cancel: string = "Cancel";
	@Input() hideX: boolean;
	@Input() staticBackground: boolean;
  @Input() disableAction: boolean = false;

	_message: SafeHtml;
	@Input() set message(value: string) {
  		this._message = this.sanitizer.bypassSecurityTrustHtml(value);
	}


	@Output() doAction: EventEmitter<boolean> = new EventEmitter();
	@Output() doCancel: EventEmitter<boolean> = new EventEmitter();

	constructor(private sanitizer: DomSanitizer) { }

	ngOnInit(): void {

	}

	emitAction() {
		this.doAction.emit(true);
	}

	emitCancel() {
		this.doCancel.emit(true);
	}

}
